"use strict";


(function (global) {

  /**
  * Предоставляет дополнительные методы для работы с реквизитами. 
  *
  * @mixin WebAccess.mixins.requisitesMixin
  * @since 5.0.0.7100  
  */
  var requisitesMixin = {

    /**
    * Ассоциация класса реквизита по его типу.
    *
    * @method WebAccess.mixins.requisitesMixin._createRequisite
    * @private
    * @since 5.0.0.7100
    * @return {Object}
    */
    _createRequisite: function (reqName, reqData, opt_isDetail, opt_grid) {
      var REQ;

      if (opt_isDetail)
        var REQ = WA.CMP.wrappers.form.requisites._details;
      else {
        var REQ = WA.CMP.wrappers.form.requisites;
      }

      switch (reqData.type) {
        case "string":
        case "text":        
          return new REQ.Text(reqName, reqData, this, opt_grid);
        case "pick":
          return new REQ.Pick(reqName, reqData, this, opt_grid);
        case "date":
          return new REQ.Date(reqName, reqData, this, opt_grid);
        case "integer":
        case "largeinteger":
        case "float":
          return new REQ.Integer(reqName, reqData, this, opt_grid);
        case "reference":
          return new REQ.Reference(reqName, reqData, this, opt_grid);
        case "document":
          return new REQ.Document(reqName, reqData, this, opt_grid);
        case "radio":
          return new REQ.Radio(reqName, reqData, this, opt_grid);
        case "checkbox":
          return new REQ.CheckBox(reqName, reqData, this, opt_grid);
        case "objectList":
          return new REQ.ObjectList(reqName, reqData, this, opt_grid);
        default:
          return new REQ.BaseRequisite(reqName, reqData, this, opt_grid);
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Начальное заполнение реквизитов формы данными.
    *
    * @method WebAccess.mixins.requisitesMixin._initRequisiteValues
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.mixins.requisitesMixin}
    */
    _initRequisiteValues: function (reqsData) {
      var me = this;

      if (me.isDisabled()) {
        me.disable();
      } else {
        //Шамов А.: Закоментировал потому, что дизэйблятся все контролы реквизита на всех вкладках, если на какой-нибуль из вкладок реквизит задизэйблен.
        //me._disableReadOnlyFields();
      }

      var globalReqValuesInit = $.Deferred();
      if (me._reqValuesInit) me._reqValuesInit.push(globalReqValuesInit);

      for (var reqName in reqsData) {
        if (me.requisites[reqName].isRendered()) {
          (function (_reqName, req) {

            var currReqValueInit = $.Deferred();
            if (me._reqValuesInit) me._reqValuesInit.push(currReqValueInit);

            $.when(req.Init).then(function () {
              req.setValue(reqsData[_reqName].value, reqsData[_reqName].displayValue, false)._bindMirrors()._isChanged = false;
              currReqValueInit.resolve();
            });

          })(reqName, me.requisites[reqName]);
        }
      };

      UnbindBeforeUnload();
      BindBeforeUnload();

      $("input.input").change(function () { $(this).attr("title", $(this).val()) });

      globalReqValuesInit.resolve();

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Свзяать реквизиты с множественными контролами
    * @private
    * @method WebAccess.mixins.requisitesMixin._disable
    * @since 5.0.0.7100
    */
    _bindMirrors: function (reqsData) {
      for (var reqName in reqsData) {
        if (this.requisites[reqName].isRendered()) {
          this.requisites[reqName]._bindMirrors();
        }
      }
      return this;
    },

    /**
    * Установить для всех реквизитов состояние "Только чтение", 
    * и скрыть ссылку "Добавить строку".
    *
    * @method WebAccess.mixins.requisitesMixin._disable
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.mixins.requisitesMixin}
    */
    _disable: function () {
      var reqs = this.requisites.toArray();
      reqs.forEach(function (requisite) {
        requisite.disable();
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Снять у всех реквизитов состояние "Только чтение".
    *
    * @method WebAccess.mixins.requisitesMixin._enable
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.mixins.requisitesMixin}
    */
    _enable: function () {
      var reqs = this.requisites.toArray();
      var parentTable = this._parentTable;
      if (parentTable) {
        var columns = parentTable.columns;
        reqs.forEach(function (requisite) {
          var reqName = requisite.name;
          var currentColumn = columns[reqName];
          if (!currentColumn.isDisabled()) {
            requisite.enable();
          }
        });
      } else {
        reqs.forEach(function (requisite) {
          requisite.enable();
        });
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Используется при иницалиции формы - отключает все видимые 
    * поля для которых доступ только на чтение.
    *
    * @method WebAccess.mixins.requisitesMixin._disableReadOnlyFields
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.mixins.requisitesMixin}
    */
    _disableReadOnlyFields: function () {
      var reqs = this.requisites.toArray();
      var parentTable = this._parentTable;
      if (parentTable) {
        var columns = parentTable.columns;
        reqs.forEach(function (requisite) {
          var reqName = requisite.name;
          var currentColumn = columns[reqName];
          if (currentColumn.isDisabled()) {
            requisite.disable();
          }
        });
      } else {
        reqs.forEach(function (requisite) {
          if (requisite.isDisabled()) requisite.enable();
        });
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Возвращает реквизит по ИД элемента управления.
    *
    * @method WebAccess.mixins.requisitesMixin.getRequisiteByControlId
    * @param {string} controlId ИД HTML-элемента
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Объект реквизита или значение null, если реквизит не найден.
    * @since 5.0.0.7100
    */
    getRequisiteByControlId: function (controlId) {
      var reqs = this.requisites.toArray();
      for (var reqI = 0; reqI < reqs.length; reqI++) {
        var req = reqs[reqI];
        for (var i = 0; i < req.controlsIds.length; i++) {
          if (controlId === req.controlsIds[i]) {
            return req;
          }
        }
      }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак изменения реквизитов.
    *
    * @method WebAccess.mixins.requisitesMixin.isChanged
    * @return {boolean} True – реквизиты были изменены, иначе False.
    * @since 5.0.0.7100
    */
    isChanged: function () {
      var reqs = this.requisites.toArray();
      for (var reqI = 0; reqI < reqs.length; reqI++) {
        if (reqs[reqI].isChanged()) {
          return true;
        }
      }
      return false;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.requisitesMixin = requisitesMixin;
})(window.WebAccess.mixins);